import { useState, useEffect, useMemo, useCallback } from "react";
function useOrderingQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const [isVertical, setIsVertical] = useState(
    () => typeof window !== "undefined" ? window.innerWidth < 900 : true
  );
  const isSolved = solveResult !== null && solveResult !== void 0;
  const shouldShowCorrectAnswers = showReallyTrue || isShowingCorrectAnswers;
  useEffect(() => {
    const handleResize = () => {
      setIsVertical(window.innerWidth < 900);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const computedInitialChoices = useMemo(() => {
    if (initialAnswersProp && initialAnswersProp.length > 0) {
      return initialAnswersProp.map((key) => quiz.choices.find((c) => c.key === key)).filter((c) => c !== void 0);
    }
    if (isViewSolved && (solveResult == null ? void 0 : solveResult.correctAnswers) && solveResult.correctAnswers.length > 0) {
      return solveResult.correctAnswers.map((key) => quiz.choices.find((c) => c.key === key)).filter((c) => c !== void 0);
    }
    return [...quiz.choices];
  }, [quiz.choices, initialAnswersProp, isViewSolved, solveResult == null ? void 0 : solveResult.correctAnswers]);
  const [orderedChoices, setOrderedChoices] = useState(computedInitialChoices);
  const [submittedChoices, setSubmittedChoices] = useState(null);
  useEffect(() => {
    setOrderedChoices(computedInitialChoices);
  }, [computedInitialChoices]);
  useEffect(() => {
    if (isSolved && !submittedChoices) {
      setSubmittedChoices(orderedChoices);
    }
  }, [isSolved, submittedChoices, orderedChoices]);
  useEffect(() => {
    if (!isSolved) return;
    if (shouldShowCorrectAnswers && (solveResult == null ? void 0 : solveResult.correctAnswers) && solveResult.correctAnswers.length > 0) {
      const reordered = solveResult.correctAnswers.map((key) => quiz.choices.find((c) => c.key === key)).filter((c) => c !== void 0);
      setOrderedChoices(reordered);
    } else if (submittedChoices) {
      setOrderedChoices(submittedChoices);
    }
  }, [shouldShowCorrectAnswers, isSolved, solveResult == null ? void 0 : solveResult.correctAnswers, quiz.choices, submittedChoices]);
  useEffect(() => {
    onAnswerChange == null ? void 0 : onAnswerChange(orderedChoices.map((c) => c.key));
  }, [orderedChoices, onAnswerChange]);
  const handleReorder = useCallback((oldIndex, newIndex) => {
    setOrderedChoices((prev) => {
      const next = [...prev];
      const [removed] = next.splice(oldIndex, 1);
      next.splice(newIndex, 0, removed);
      return next;
    });
  }, []);
  const canSubmit = true;
  const handleSubmit = useCallback(() => {
    if (isSolved) return;
    const elapsedTime = Date.now() - startTime;
    const answers = orderedChoices.map((c) => c.key);
    onSolve == null ? void 0 : onSolve(quizId, answers, quiz.vars, elapsedTime);
  }, [isSolved, startTime, orderedChoices, onSolve, quizId, quiz.vars]);
  return {
    orderedChoices,
    setOrderedChoices,
    isVertical,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleReorder,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useOrderingQuiz
};
//# sourceMappingURL=use-ordering-quiz.js.map
